import axios from "@/api/axiosInstance";
import { FetchProductsHistoryReportParams } from "./types";

export const fetchProductsHistoryReportCsv = async (
  params: Omit<FetchProductsHistoryReportParams, "page" | "pageSize"> = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/reports/products-history/export",
    { responseType: "blob", params },
  );
  return response.data;
};
